/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import { BadRequestFragmentDoc } from '../../../../core/fragments/core.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSuggestedDcrFieldsQueryVariables = Types.Exact<{
	input: Types.SuggestedDcrFieldsInput;
}>;

export type GetSuggestedDcrFieldsQuery = {
	__typename?: 'Query';
	suggestedDcrFields:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| { __typename?: 'Forbidden'; message: string }
		| { __typename?: 'SuggestedDCRFields'; results: Array<string> };
};

export const GetSuggestedDcrFieldsDocument = gql`
	query GetSuggestedDcrFields($input: SuggestedDCRFieldsInput!) {
		suggestedDcrFields(input: $input) {
			... on SuggestedDCRFields {
				results
			}
			... on Forbidden {
				message
			}
			...BadRequest
		}
	}
	${BadRequestFragmentDoc}
`;

/**
 * __useGetSuggestedDcrFieldsQuery__
 *
 * To run a query within a React component, call `useGetSuggestedDcrFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuggestedDcrFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuggestedDcrFieldsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSuggestedDcrFieldsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetSuggestedDcrFieldsQuery,
		GetSuggestedDcrFieldsQueryVariables
	> &
		(
			| { variables: GetSuggestedDcrFieldsQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetSuggestedDcrFieldsQuery,
		GetSuggestedDcrFieldsQueryVariables
	>(GetSuggestedDcrFieldsDocument, options);
}
export function useGetSuggestedDcrFieldsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetSuggestedDcrFieldsQuery,
		GetSuggestedDcrFieldsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetSuggestedDcrFieldsQuery,
		GetSuggestedDcrFieldsQueryVariables
	>(GetSuggestedDcrFieldsDocument, options);
}
export function useGetSuggestedDcrFieldsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetSuggestedDcrFieldsQuery,
				GetSuggestedDcrFieldsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetSuggestedDcrFieldsQuery,
		GetSuggestedDcrFieldsQueryVariables
	>(GetSuggestedDcrFieldsDocument, options);
}
export type GetSuggestedDcrFieldsQueryHookResult = ReturnType<
	typeof useGetSuggestedDcrFieldsQuery
>;
export type GetSuggestedDcrFieldsLazyQueryHookResult = ReturnType<
	typeof useGetSuggestedDcrFieldsLazyQuery
>;
export type GetSuggestedDcrFieldsSuspenseQueryHookResult = ReturnType<
	typeof useGetSuggestedDcrFieldsSuspenseQuery
>;
export type GetSuggestedDcrFieldsQueryResult = Apollo.QueryResult<
	GetSuggestedDcrFieldsQuery,
	GetSuggestedDcrFieldsQueryVariables
>;
